import React from "react";
import MaterialTable from "material-table";
import TablePagination from "@material-ui/core/TablePagination";
import SubPolicyTable from "../SubPolicyTable/SubPolicyTable";
import { theme as themeConfig } from "../../themes/themes";
import {
  ContentTable,
  ContentTableSubPolicy,
} from "./PolicyQueueListComponent.styled";

const PolicyQueueListComponent = ({
  data,
  columns,
  page,
  allPages,
  rowsPerPage,
  rowsPerPageOptions,
  handleChangeRowsPerPage,
  handleChangePage,
  changeState,
  handleEdit,
  setOpenDeleteModal,
  selectedMenu,
}) => {
  const policyTable = () => {
    return (
      <MaterialTable
        title=""
        columns={columns}
        data={data}
        detailPanel={[
          {
            tooltip: "Show sub policy",
            render: (rowData) => {
              return (
                <ContentTableSubPolicy>
                  <SubPolicyTable
                    data={rowData?.policySubPolicies}
                    changeState={changeState}
                    handleEdit={handleEdit}
                    setOpenDeleteModal={setOpenDeleteModal}
                  />
                </ContentTableSubPolicy>
              );
            },
          },
        ]}
        // onRowClick={(index)=>{console.log(index + 'row clicked')}}
        // actions={[
        //   {
        //     icon: 'save',
        //     tooltip: 'Save User',
        //     onClick: (event, rowData) => alert("You saved " + rowData.name)
        //   }
        // ]}
        options={{
          detailPanelType: "single",
          search: false,
          paging: false,
          maxBodyHeight: 450,
          headerStyle: {
            zIndex: 1,
            fontWeight: "bold",
            backgroundColor: themeConfig.neutral.gray[800],
          },
          cellStyle: {
            padding: "5px 10px",
          },
        }}
      ></MaterialTable>
    );
  };

  const queueTable = () => {
    return (
      <MaterialTable
        title=""
        columns={columns}
        data={data}
        options={{
          search: false,
          paging: false,
          maxBodyHeight: 450,
          headerStyle: {
            zIndex: 1,
            fontWeight: "bold",
            backgroundColor: themeConfig.neutral.gray[800],
          },
          cellStyle: {
            padding: "5px 10px",
          },
          rowStyle: {},
        }}
      ></MaterialTable>
    );
  };

  return (
    <>
      <ContentTable>
        {selectedMenu === "policy" ? policyTable() : queueTable()}
        {data.length > 0 ? (
          <TablePagination
            component="div"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
            count={allPages}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : (
          <></>
        )}
      </ContentTable>
    </>
  );
};

export default PolicyQueueListComponent;
